import React, { useState } from 'react';
import AllMarketingBucketList from './AllMarketingBucketList';
import MarketingBucketList from './MarketingBucketList';

const MarketingBucketListWrapper: React.FC = () => {
  const [selectedBucketId, setSelectedBucketId] = useState<string | null>(null);
  const [selectedBucketName, setSelectedBucketName] = useState<string>('');

  const handleBucketSelect = (bucketId: string, bucketName: string) => {
    console.log('Wrapper: Bucket selected:', bucketId, bucketName);
    setSelectedBucketId(bucketId);
    setSelectedBucketName(bucketName);
  };

  const handleBackToBuckets = () => {
    console.log('Wrapper: Back to buckets');
    setSelectedBucketId(null);
    setSelectedBucketName('');
  };

  console.log('Wrapper render - selectedBucketId:', selectedBucketId, 'selectedBucketName:', selectedBucketName);

  if (selectedBucketId) {
    console.log('Wrapper: Rendering MarketingBucketList component');
    return (
      <MarketingBucketList 
        bucketId={selectedBucketId} 
        bucketName={selectedBucketName || `Bucket ${selectedBucketId}`} 
        onBackToBuckets={handleBackToBuckets} 
      />
    );
  }

  console.log('Wrapper: Rendering AllMarketingBucketList component');
  return <AllMarketingBucketList onBucketSelect={handleBucketSelect} />;
};

export default MarketingBucketListWrapper; 